// Session-expiration side effect for the IAS deployment. Deliberately avoids
// upstream's `redux/auth`'s `logout` thunk because that ends in
// `window.location.reload()` — which wipes the redux state (including the
// just-opened `SessionExpiredModal`) and drops the user on `/auth/login`
// before they see anything. We only want to invalidate the Metabase cookie
// and clear the current-user redux slice; the modal (mounted above
// `AppSettingsGetter`) then renders on top of whatever page the user was on.

import { sessionApi } from "metabase/api/session";
import type { DispatchFn } from "metabase/redux/hooks";
import { clearCurrentUser } from "metabase/redux/user";

import { openSessionExpired } from "./state";

export const iasExpireSession = () => async (dispatch: DispatchFn) => {
  try {
    await dispatch(sessionApi.endpoints.deleteSession.initiate()).unwrap();
  } catch {
    // The cookie may already be dead (that's precisely how we got here) so a
    // 401/404 from `DELETE /api/session` is expected and non-fatal.
  }
  dispatch(clearCurrentUser());
  dispatch(openSessionExpired());
};
